import greedCautious from '@/assets/mitra-3d/greed-cautious.png'
import greedExtreme from '@/assets/mitra-3d/greed-extreme.png'
import greedFear from '@/assets/mitra-3d/greed-fear.png'
import greedGreed from '@/assets/mitra-3d/greed-greed.png'
import greedNeutral from '@/assets/mitra-3d/greed-neutral.png'
import greedWarm from '@/assets/mitra-3d/greed-warm.png'
import type { HoverPopVariant } from '@/components/motion/HoverPop'
import type { MoodBandKey } from '@/features/market/lib/mood'
import type { MarketMood } from '@/schemas/market'

interface MoodArt {
  src: string
  /** How the mascot arrives on hover, in keeping with the mood. */
  entrance: HoverPopVariant
}

const ART: Readonly<Record<MoodBandKey, MoodArt>> = {
  fear: { src: greedFear, entrance: 'shiver' },
  cautious: { src: greedCautious, entrance: 'wobble' },
  neutral: { src: greedNeutral, entrance: 'pop' },
  warm: { src: greedWarm, entrance: 'bob' },
  greed: { src: greedGreed, entrance: 'jump' },
}

/** Mitra for a mood: the band's pose, or the extreme greed pose at the top of the range. */
export const moodArt = (mood: MarketMood): MoodArt =>
  mood.extreme ? { src: greedExtreme, entrance: 'jump' } : ART[mood.band]
